<template>
  <div class="newdetail">
    <div class="banner" v-if="isMobile" :style="{backgroundImage:`url(${news_data.mbanner})`}">
      <!-- <img src="../assets/news首页.png" alt=""> -->
        <h1>新闻</h1>
        <div class="inner_btn">
            <button @click="goToContact(2)" class="inner-le">生态合作</button>
            <button @click="goToContact(3)" class="inner-ri">联系我们</button>
         </div>
    </div>
    <div class="banner" v-else :style="{backgroundImage:`url(${news_data.banner})`}">
      <!-- <img src="../assets/news首页.png" alt=""> -->
        <h1>新闻</h1>
        <div class="inner_btn">
            <button @click="goToContact(2)" class="inner-le">生态合作</button>
            <button @click="goToContact(3)" class="inner-ri">联系我们</button>
         </div>
    </div>
    <div class="new-left">
      <div class="new-title">
        <h1 style="margin-bottom: 1em;">{{news_data.name}}</h1>
        <span style="font-weight: 400;">发布时间：{{ news_data.newsTime }}</span>
      </div>
      <div class="content" v-html="news_data.context"></div>
    </div>
    <!-- <div class="new-right">
      <div class="box">
        <div class="box-main">
          <h3>热门文章</h3>
          <ul v-for="item in 5" :key="item">
            <li @click="goto_itemnews" style="cursor: pointer;">item:{{ item }}</li>
          </ul>
        </div>
      </div>
    </div> -->
  </div>
  <!-- <div class="footer">
      <div class="prev">
         上一篇&nbsp;&nbsp;{{ messageprev  }}
      </div>
      <div class="next">
        下一篇&nbsp;&nbsp;{{ messagenext  }}
    </div>
  </div> -->
</template>

<script setup name="NewsDetail">
import { ref, onMounted, onUnmounted } from 'vue'
import { getNewsDetail } from '@/api/news';
import { useRoute } from 'vue-router';
const route = useRoute();
const id = route.query.id;
const news_data=ref([])
onMounted(() => {
  window.scrollTo(0, 0);
  checkMobile();
  window.addEventListener('resize', checkMobile);
  newsrender()
})
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
})
const isMobile = ref(false);
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 1024;
};
const parseImageContent = (content) => {
  if (!content) return [];
  if (Array.isArray(content)) {
    return content;
  }
  try {
    const parsed = JSON.parse(content);
    return Array.isArray(parsed) ? parsed : [content];
  } catch (error) {
    return content.split(',').map(url => url.trim()).filter(url => url.length > 0);
  }
};
const emit = defineEmits(['scroll-to-contact'])
const parseListContent = (content) => {
  if (!content) return [];
  return content
    .split('\n')
    .map(item => item.trim())
    .filter(item => item.length > 0)
    .map(item => item.replace(/^[•·\-\*]\s*/, '')); // 移除开头的符号
};
function goToContact(type) {
  emit('scroll-to-contact', type)
}
async function newsrender() {
  const news_res = await getNewsDetail(id)
  news_data.value = news_res.data
}
function splitDate(dateStr) {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    return null;
  }
  return {
    year: date.getFullYear(),
    month: String(date.getMonth() + 1).padStart(2, '0'),
    day: String(date.getDate()).padStart(2, '0')
  };
}
</script>

<style scoped>
.newdetail {
  width: 100%;
}
.banner{
  overflow: hidden;
  width: 100%;
  height: 12em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color:white;
  background-color: #ddd;
  margin-bottom: 4em;
  background-size: 100% 100%;
  background-position: center;
  text-align: left;
  background-repeat: no-repeat;
}
.inner_btn{
  margin-left: 18%;
}
.inner-le,.inner-ri{
  width: 10em;
  height: 2.5em;
  border-radius: 1.5em;
  font-size: 1em;
  border:transparent;
  cursor: pointer;
  margin: 2em auto;
}
.inner-le{
  background-color: orange;
  color: white;
  margin-right: 1em;
}
.inner-ri{
  background-color: skyblue;
  color: white;
}
.banner h1{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  width: 65%;
  margin: 0 auto;
  margin-top: 1em;
  margin-left: 18%;
}
.newdetail .new-left {
  width: 60%;
  margin: 2em auto;
}
.newdetail .new-left .new-title {
  width: 100%;
  text-align: center;
  margin-bottom: 2em;
}
.newdetail .new-left h3{
  text-align: center;
  margin-bottom: 1em;
}
.newdetail .new-left p{
  width: 80%;
  text-indent: 2em;
  font-size:15px;
  line-height: 1.8em;
  margin: 0.5em auto;
}
:deep(.content) {
  line-height: 1.8em;
  font-size: 15px;
}
:deep(.content img) {
  max-width: 100% !important;
  height: auto !important;
  object-fit: contain;
}
:deep(.content p) {
  margin: 0.5em 0;
}
:deep(.content h1),
:deep(.content h2),
:deep(.content h3),
:deep(.content h4) {
  margin: 1em 0 0.5em;
}
.newdetail .new-right{
  width: 30%;
}
.item{
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 210px;
  margin: 20px auto;
}
.item .item1{
  width: 29%;
  height: 100%;
  background-color: #ddd;
}
.item .item2{
  width: 69%;
  height: 100%;
  background-color:#fff;
  border: 1px solid #ddd;
}
.box{
  width: 90%;
  border:1px solid #ddd;
  margin: 6em auto;
  border-radius: 5px;
  box-shadow: 0px 0px 6px 1px #ddd;
}
.box-main{
  width: 90%;
  height: 100%;
  margin: 0 auto;
}
.box-main h3{
  height: 60px; 
  line-height: 60px;
  border-bottom: 1px solid #ddd;
}
.box-main ul{
  width: 100%;
  height: 100%;
}
.box-main ul li{
  list-style: none;
  margin-top: 20px;
}
.box-main ul:last-child{
  margin-bottom: 40px;
}
.el-card{
  width: 80%;
  height: 50%;
  margin: 0 auto;
}
.footer{
  width: 80%;
  height: 2.5em;
  display: flex;
  line-height: 2.5em;
  justify-content: space-between;
  background-color: #ddd;
  margin: 4em auto;
}
.dot-list {
  margin: 1em 0;
  padding-left: 1.2em;
}
.dot-list li {
  font-weight: bold;
  list-style: disc;
  font-size: 20px;
  margin: 0.5em 0;
  line-height: 1.6;
}
.single-image {
  width: 100%;
  text-align: center;
  margin: 2em 0;
}

.single-img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.multiple-images {
  width: 100%;
  margin: 2em 0;
}

.image-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1em;
  padding: 1em 0;
}

.gallery-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.gallery-img:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}
.sol-h{
  display: flex;
  align-items: center;
  width: 65%;
  height: 6em;
}
.sol-h .box{
  display: inline-block;
  width: 0.5em;
  height: 2em;
  background-color: #0073FF;
}
.sol-h h1{
  display: flex;
  height: 3em;
  line-height: 3em;
  text-align: left;
  margin-left: -20px;
}
.sol-p{
  width: 100%;
  text-indent: 2em;
  line-height: 2em;
}
@media (max-width: 1024px)  {
  .banner{
    height: 12em;
    margin-bottom: 1em;
    text-align: center;
  }
  .banner h1{
  font-size: 1.2em;
  margin-top: 4em;
  }
  .inner_btn{
  margin-left: 0;
  }
  .inner-le,.inner-ri{
  font-size: 0.8em;
  height: 2.5em;
}
  .newdetail{
    width: 100%;
  }
  .newdetail .new-left {
    width: 90%;
  }
  .newdetail .new-left p{
    width: 90%;
  }
}
.image-gallery {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 0.5em;
  }
  
  .gallery-img {
    height: 150px;
  }
</style>